export default [
    {
        title: 'Trendyol',
        icon: 'ShoppingBagIcon',
        children: [
            {
                title: 'Ürünler',
                route: 'trendyol',
                icon: 'ShoppingCartIcon',
            },
            {
                title: 'Ürün Açma',
                icon: 'BoxIcon',
                route: 'trendyol-urunacma',
            },
            {
                title: 'Tedarikçi Ürünleri Excel Listesi',
                icon: 'BoxIcon',
                route: 'trendyol-export-supplier-product',
            },
            {
                title: 'Eşleştirme',
                icon: 'BoxIcon',
                route: 'trendyol-eslestirme',
            },
            {
                title: 'Ürünler V2',
                icon: 'BoxIcon',
                route: 'trendyol-urunler-v2',
            },
        ],
    }
]
